import { Link } from "react-router-dom";
import { Paperclip } from "lucide-react";
import { useState } from "react";
import GoogleDrivePicker from "../../reusableUI/google/GoogleDrivePicker";
import { Model } from "../../../models/model";

export const ContainerFiles = ({
  entity,
  entityId,
  filesList,
  form = null,
  setForm = null,
}) => {
  const [openAddFiles, setOpenAddFiles] = useState(false);

  const getAttachments = async () => {
    const params = {
      entity,
      entityId,
    };

    const results = await Model.getAll({
      url: `adjuntos/?${new URLSearchParams(params).toString()}`,
    });

    setForm({
      ...form,
      files: results || [],
    });
  };

  const handleDriveFileSelected = async (file) => {
    try {
      const dataForm = {
        tipo_entidad: entity,
        id_entidad: entityId,
        drive_file_id: file.driveFileId,
        nombre: file.nombre,
        mime_type: file.mimeType,
        tamano: file.sizeBytes,
        web_view_link: file.url,
        drive_folder_id: file.parentId,
        icon_url: file.iconUrl,
      };

      const result = await Model.save({
        url: "adjuntos",
        dataForm,
        resultData: true,
      });

      if (result?.id) {
        await getAttachments();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="p-comment-block">
      <h5 className="text-base flex items-center justify-between">
        <span className="flex items-center">
          <Paperclip size={18} />
          <span className="ms-2">Archivos ({`${filesList?.length || 0}`})</span>
        </span>
        <Link
          to=""
          onClick={() => setOpenAddFiles(true)}
          className="text-sm me-2"
        >
          + Añadir archivo
        </Link>
      </h5>

      {openAddFiles && (
        <div className="ms-4 mb-3">
          <GoogleDrivePicker onSelect={handleDriveFileSelected} />
        </div>
      )}

      <div className="ms-4">
        {filesList?.map((f) => (
          <a
            id={f.id}
            className="lowercase text-base text-left flex items-center gap-1 py-2"
            href={f.web_view_link}
            target="_blank"
            rel="noreferrer"
          >
            <span>
              <img src={f.icon_url} alt="icon" />
            </span>
            <span>{f.nombre}</span>
          </a>
        ))}
      </div>
    </div>
  );
};
